/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { convertColumndef, convertRowData } from '../../common/tableConfig/GroupStudentDataConfig';
import tableStyle from '../../component/common/style/index.scss';
import style from '../../styles.module.scss';
import { EDWDropDown } from "../common/dropDown/DropDown";

export default class AssessmentTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            coloumnDef: [],
            rowData: [],
            pinnedTopRow:[],
            icons: props.studentDataConfig.icons,
            height: props.height,
            studentDataConfig: props.studentDataConfig,
            viewBy: props.viewBy,
            assessmentTypeArr: props.assessmentTypeArr,
            customAssessmentTypeArr: props.assessmentTypeArr,
            defaultColDef: props.defaultColDef
        };
    }
    componentDidMount() {
       this.generateGridConfig(this.state.studentDataConfig, this.state.viewBy, this.state.customAssessmentTypeArr)
	}
     componentDidUpdate(prevProps) {
          if (prevProps.studentDataConfig !== this.props.studentDataConfig){
              this.generateGridConfig(this.props.studentDataConfig, this.state.viewBy, this.state.customAssessmentTypeArr)
         }          
          this.props.updateExportData({ type: "group_widget_2", rowData: {'rowsArray':this.state.rowData,'pinnedTopRow': this.state.pinnedTopRow}, columnDefs: this.state.coloumnDef });               
    } 
    generateGridConfig(studentDataConfig, viewBy, customAssessmentTypeArr) {
        let { schoolId, groupId, courseId, subjectId} =this.props
        let columndef = convertColumndef(viewBy, studentDataConfig, customAssessmentTypeArr, schoolId, groupId, courseId, subjectId);
        let rowData = convertRowData(studentDataConfig, viewBy);
        rowData.rowsArray.map(e=>e["courseId"]=this.props.courseId);
        rowData.rowsArray.map(e=>e["groupId"]=this.props.groupId);
        this.setState({ rowData: rowData.rowsArray, pinnedTopRow: rowData.pinnedTopRow, customAssessmentTypeArr: customAssessmentTypeArr, coloumnDef: columndef, isDataFetch: true, studentDataConfig: studentDataConfig });               
        this.props.updateExportData({ type: "group_widget_2", rowData: rowData, columnDefs: columndef});               
    }
    sortByView = (value) => {
        if(value !=this.state.viewBy){
            this.setState({ viewBy: value });
            this.generateGridConfig(this.state.studentDataConfig, value, this.state.customAssessmentTypeArr);
            this.gridApi.setColumnDefs(this.state.coloumnDef);
        }
       
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.refreshCells(params);
        this.gridApi.setColumnDefs(this.state.coloumnDef);
        this.gridApi.setHeaderHeight(80);
       
       };
    columnCustomize=(e)=>{
       this.generateGridConfig(this.state.studentDataConfig, this.state.viewBy, e)        
    }
    onColumnResized=(params)=> {
      this.gridApi = params.api;
         this.gridApi.resetRowHeights();
    }
    getRowHeight = (params) => {
        return params.data.rowHeight;
    }
    isKs4 = data => {
        return data && data.toLowerCase().indexOf('edexcel') > -1
    }
    sort_by_key = (array, key) => {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    onSortChanged = (params) => {
        let sortModel = params.api.getSortModel();
        let sortedRowData = this.sort_by_key(this.state.rowData, sortModel[0]["colId"]);
        this.setState({ rowData: sortedRowData });
    }
    render() {
        const isKs4 = this.isKs4(this.props.courseName || '');
        return (
            <div>

                <div className="col">
                    {/* <div className="row contentFilter content-row-padding">
                        <div className="col-md-6"></div>

                        <div className="col-md-6">
                            <button className="Button download-btn btn-font"><span className={tableStyle.iconGeneralDownload}></span>Download student summary</button>
                        </div>
                    </div> */}
                    <div className="row contentFilter">
                        <div className="col-md-4 "></div>
                        {
                            isKs4 && (<div className="col-md-4 "></div>)
                        }
                        <div className="col-md-4">
                            <label className={style.lblColor}>Assessment type</label>
                            <EDWDropDown
                                items={this.state.assessmentTypeArr.map(id => {
                                    return {
                                        id, label: id
                                    }
                                })}
                                onChange={this.columnCustomize}
                                label="All"
                                selectAllLabel="All assessments"
                                multiple
                                value={this.state.customAssessmentTypeArr.filter(id => id)}
                            />
                        </div>
                        {
                            !isKs4 && (
                        <div className="col-md-4 ">
                            <label className={style.lblColor}>Show</label>
                            <EDWDropDown
                                items={[{ label: 'Indicative grade', id: 'indicativeGradeValue' }, { label: 'Steps', id: 'stepValue' }]}
                                onChange={this.sortByView}
                                label="Show"
                                value={this.state.viewBy}
                            />
                        </div>)
                         }

                    </div>

                </div>
                <div className="ag-theme-alpine" id="blind" style={{ height: '', width: 'auto' }}>
                    <AgGridReact tooltipShowDelay={0}
                        columnDefs={this.state.coloumnDef}
                        rowData={this.state.rowData}
                        icons={this.state.icons}
                        defaultColDef={this.state.defaultColDef}
                        onGridReady={this.onGridReady}
                        getRowHeight={this.getRowHeight}
                        pinnedTopRowData={this.state.pinnedTopRow}
                        domLayout="autoHeight"
                        onColumnResized={this.onColumnResized}
                        onSortChanged={this.onSortChanged.bind(this)}
                       
                    >
                    </AgGridReact>
                </div>
            </div>
        )
    }
}